
import { isEqual } from 'lodash'
import { getVehicleData } from '../api.js'

import settings from '../settings.js'
import notifications from '../notifications.js'

const _vars = {
  currVehicleData: undefined,

  getVehicleDataPromise: undefined,
  getVehicleDataCallback: undefined,

  currApiPromise: undefined,
  currApiParams: undefined,
}

function _getVehicleDataFromServer(apiParams) {
  function _responseCallback(response) {
    _vars.currVehicleData = response.data
    if (_vars.getVehicleDataCallback) {
      _vars.getVehicleDataCallback()
    }
  }

  function _responseError(error) {
    notifications.pushError('Unable to get Vehicle data from server.', error)
  }

  if (_vars.currApiPromise === undefined || !isEqual(apiParams, _vars.currApiParams)) {
    _vars.currApiPromise = getVehicleData(apiParams)
    _vars.currApiPromise.then(_responseCallback).catch(_responseError)
  }
  return _vars.currApiPromise
}

function _getVehicleData(id) {
  if (_vars.currVehicleData) {
    return Promise.resolve(_getVehicleDataSync(id))
  }
  else {
    _vars.getDataPromise = new Promise((resolve) => {
      _vars.getVehicleDataCallback = function () {
        resolve(_getVehicleDataSync(id))
      }
    })
    return _vars.getVehicleDataPromise
  }
}

function _getVehicleDataSync(id) {
  if (id === undefined) {
    return _vars.currVehicleData
  }

  return _vars.currVehicleData.find(elem => elem.db_id === id)
}

function getNumPerPage() {
  return settings.vehicleList.numPerPage
}

function getCurrentPage() {
  return settings.vehicleList.currentPage
}

function setCurrentPage(pageNumber) {
  settings.vehicleList.currentPage = pageNumber
}

function _init() {
  // do nothing
}

_init()

export default {
  getVehicleDataFromServer: _getVehicleDataFromServer,
  getVehicleData: _getVehicleData,
  getVehicleDataSync: _getVehicleDataSync,
  getNumPerPage: getNumPerPage,
  getCurrentPage: getCurrentPage,
  setCurrentPage: setCurrentPage,
}
